import {PrepareUploadResponse} from '../../../entities/users/model';
import {api} from '../../../shared';
import {FundraiserImagesModel} from '../model';

export const fundraiserImageApi = {
  getImages: async (fundraiserId: string) => {
    const {data} = await api.get<FundraiserImagesModel>(`/api/fundraising/admin/appeals/${fundraiserId}/images`);
    return data;
  },

  prepareUpload: async (contentTypes: string[]) => {
    const {data} = await api.post<PrepareUploadResponse>('/api/files/public/prepare-upload', {
      contentTypes,
    });
    return data;
  },
  // Методы для работы с изображениями фандрайзеров
  uploadMainImage: async (fundraiserId: string, payload: Record<string, any>) => {
    const {data} = await api.post<void>(`/api/fundraising/admin/appeals/${fundraiserId}/images/main`, payload);
    return data;
  },

  uploadFeedImage: async (fundraiserId: string, payload: Record<string, any>) => {
    const {data} = await api.post<void>(`/api/fundraising/admin/appeals/${fundraiserId}/images/feed`, payload);
    return data;
  },

  uploadAvatarImage: async (fundraiserId: string, payload: Record<string, any>) => {
    const {data} = await api.post<void>(`/api/fundraising/admin/appeals/${fundraiserId}/images/avatar`, payload);
    return data;
  },

  deleteMainImage: async (fundraiserId: string, fileName: string) => {
    const {data} = await api.delete<void>(`/api/fundraising/admin/appeals/${fundraiserId}/images/main/${fileName}`);
    return data;
  },

  deleteFeedImage: async (fundraiserId: string, fileName: string) => {
    const {data} = await api.delete<void>(`/api/fundraising/admin/appeals/${fundraiserId}/images/feed/${fileName}`);
    return data;
  },

  deleteAvatarImage: async (fundraiserId: string, fileName: string) => {
    const {data} = await api.delete<void>(`/api/fundraising/admin/appeals/${fundraiserId}/images/avatar/${fileName}`);
    return data;
  },

  // Методы для обновления порядка изображений
  updateMainImagesOrder: async (fundraiserId: string, images: string[]) => {
    const {data} = await api.put<void>(`/api/fundraising/admin/appeals/${fundraiserId}/images/main`, {
      images,
    });
    return data;
  },

  updateFeedImagesOrder: async (fundraiserId: string, images: string[]) => {
    const {data} = await api.put<void>(`/api/fundraising/admin/appeals/${fundraiserId}/images/feed`, {
      images,
    });
    return data;
  },
};
